export default __webpack_public_path__ + "static/media/logo.28a47ddc.png";